<template>
  <el-form :inline="true" class="demo-form-inline">
    <el-form-item label="日期">
      <el-date-picker v-model="model.date" type="datetimerange" single-panel />
    </el-form-item>

    <el-form-item label="状态">
      <el-select v-model="model.state" placeholder="订单状态" clearable>
        <el-option label="全部" value=""/>
        <el-option label="支付成功" value="0"/>
        <el-option label="已退款" value="4"/>
        <el-option label="已退订" value="6"/>
        <el-option label="退款中" value="3"/>
        <el-option label="退款失败" value="5"/>
      </el-select>
    </el-form-item>



    <!--    <el-form-item label="支付时间">-->
    <!--      <el-date-picker v-model="model.date" type="date" placeholder="选择时间" clearable />-->
    <!--    </el-form-item>-->

    <el-form-item>
      <!-- 👇 点击触发父组件传入的 search 事件 -->
      <el-button type="primary" @click="$emit('search')">查询</el-button>
      <el-button type="primary" @click="$emit('export')">导出</el-button>
    </el-form-item>

  </el-form>
</template>

<script lang="ts" setup>
import {FormInline} from './tb_header_data'; // 引入类型
import {defineEmits, defineModel, defineProps} from 'vue';
import {Connection} from "@element-plus/icons-vue";
import {useRouter} from "vue-router"; // 引入类型

const model = defineModel<FormInline>('form-data');
// 👇 接收父组件传入的 formData
defineProps<{
  formData: FormInline;
}>();
// 定义触发的事件
defineEmits<{
  (e: 'search'): void
  (e: 'export'): void
}>();


const router = useRouter()

</script>
<style scoped>
.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}
</style>
